import axios from '../../plugins/axios';

export const getMonthlyStatesTask = ({commit}, { year, month}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/business-task-states/year/${year}/month/${month}`, config)
    .then((response) => {
    const businessesMonthlyStatesTask = response.data
    commit('SET_BUSINESSES_MONTHLY_STATES_TASK', { businessesMonthlyStatesTask })
      return response 
    })
    .catch((error) => error.response );
}

export const updateMonthlyStatesTask =({},{data, year, month}) =>{
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/business-task-states/year/${year}/month/${month}/businessId/${data.businessId}/taskId/${data.taskId}`,data,config)
    .then((response)=>response)
    .catch((error)=> error.response);
}